import { ErrorCodesWithTrackingValues } from './error-codes-with-tracking-values';
import { Provider } from './provider';
import { ProviderFlixmedia } from './provider-flixmedia';
import { ProviderLoadbee } from './provider-loadbee';

export class ProviderService {
    public static async getIframeSource(providerName: string, ean: string): Promise<string> {
        const provider = this.getProvider(providerName, ean);
        const response = await this.fetchAvailability(provider);

        if (provider.isContentAvailable(response)) {
            return provider.createIframeSrc(response);
        } else {
            return Promise.reject(ErrorCodesWithTrackingValues.ProductBlocked);
        }
    }

    private static getProvider(providerName: string, ean: string): Provider {
        switch (providerName) {
            case 'FLIXMEDIA':
                return new ProviderFlixmedia(ean);
            case 'LOADBEE':
                return new ProviderLoadbee(ean);
            default:
                throw ErrorCodesWithTrackingValues.ProviderNotFound;
        }
    }

    private static async fetchAvailability(provider: Provider): Promise<Record<string, string>> {
        try {
            const response = await fetch(provider.getAvailabilitySource());
            if (response.ok) {
                return await response.json();
            } else {
                throw ErrorCodesWithTrackingValues.ServerError;
            }
        } catch (error) {
            throw ErrorCodesWithTrackingValues.ServerError;
        }
    }
}
